export default __webpack_public_path__ + "static/media/footerpolygon.60d8d204.svg";